<template>
  <div>
    <div class="position-relative">
      <section class="section section-sm bg-custom-bg-color" style="margin-top: 90px">
        <div class="container p-0">

          <div class="bg-white p-3 rounded-3">
            <div class="d-flex align-items-center px-2">
              <h2 class="m-0 font-size-18 font-weight-500 text-custom-text">我的通知</h2>
              <div class="ml-auto">
                <!-- 分類分頁：全部／未讀。切換時只換條件重查，不影響已讀狀態 -->
                <base-button size="sm"
                             :type="activeTab === 'all' ? 'main-color' : 'white'"
                             :class="activeTab === 'all' ? '' : 'text-main-color'"
                             @click="switchTab('all')">全部
                </base-button>
                <base-button size="sm"
                             :type="activeTab === 'unread' ? 'main-color' : 'white'"
                             :class="activeTab === 'unread' ? '' : 'text-main-color'"
                             @click="switchTab('unread')">未讀
                </base-button>
              </div>
            </div>

            <div class="mt-3"></div>

            <ListDataLoadingWidget :data="item_data" :empty_text="emptyText" class="grid-container">
              <template v-slot:default="props">
                <NotificationItem :item="props.item" @read="onItemRead"></NotificationItem>
                <div class="mt-3"></div>
              </template>
            </ListDataLoadingWidget>

            <template v-if="pageCount > 1">
              <div class="mt-5"></div>
              <div>
                <base-pagination :page-count="pageCount"
                                 :total="total"
                                 :perPage="itemsPerPage"
                                 align="center"
                                 v-model="page"
                                 @input="load"
                ></base-pagination>
              </div>
            </template>
          </div>

        </div>
      </section>
    </div>
  </div>
</template>

<script>
import NotificationItem from "@/views/components/elements/NotificationItem";
import ListDataLoadingWidget from "@/layout/ListDataLoadingWidget";
import * as Api from "@/util/http_api";

export default {
  name: "NotificationsView",
  components: {
    NotificationItem,
    ListDataLoadingWidget,
  },
  data() {
    return {
      activeTab: 'all',
      page: 1,
      itemsPerPage: 10,
      item_data: null,
      pageCount: 0,
      total: 0,
    };
  },
  computed: {
    emptyText() {
      return this.activeTab === 'unread' ? '沒有未讀通知' : '目前沒有通知';
    },
  },
  created() {
    this.load();
  },
  methods: {
    switchTab(tab) {
      if (this.activeTab === tab) return;
      this.activeTab = tab;
      this.page = 1;
      this.load();
    },
    async load() {
      try {
        this.item_data = null;
        const limit = this.itemsPerPage;
        const offset = (this.page - 1) * limit;
        const result = await Api.getNotifications(limit, offset, {
          unread_only: this.activeTab === 'unread',
        });
        this.item_data = result;
        this.total = result.total;
        this.pageCount = Math.ceil(this.total / this.itemsPerPage);
      } catch (e) {
        console.error(e);
      }
    },
    // 點開單一通知才標記已讀（不像先前一進頁面就全部標成已讀）；
    // 未讀數顯示在 header 鈴鐺，這裡只負責通知它更新
    onItemRead() {
      this.$root.$emit('notifications-updated');
    },
  },
}
</script>

<style scoped>
.grid-container {
  display: grid;
  grid-gap: 5px;
}
</style>
